import { render, staticRenderFns } from "./display_demand.vue?vue&type=template&id=52bd374c"
import script from "./display_demand.vue?vue&type=script&lang=js"
export * from "./display_demand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52bd374c')) {
      api.createRecord('52bd374c', component.options)
    } else {
      api.reload('52bd374c', component.options)
    }
    module.hot.accept("./display_demand.vue?vue&type=template&id=52bd374c", function () {
      api.rerender('52bd374c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/display_activity_execution/component/display_demand.vue"
export default component.exports